import { getIsCategoryFilter, getIsSoundFilter } from "@app/routes/vocabulary/serializers";
import { ARTICULATION_SOUNDS, ARTICULATION_SOUNDS_POSITIONS, VOCABULARY_CATEGORIES, NUM_OF_SYLLABLES, SYLLABLES_SHAPES, THEMES, GRADES } from "@app/constants";
import { selectGenerateGameError, selectNumOfSyllables, selectSelectedArticulationSoundPositions, selectSelectedArticulationSounds, selectSelectedCategories, selectSelectedFilter, selectSelectedGame, selectSelectedGrades, selectSelectedThemes, selectSyllablesShapes, selectTrackEventsFunc } from "@app/routes/treatmentV3/store/activityLibrarySlice";

const getStateByType = (type, state) => {
  if (type === ARTICULATION_SOUNDS) {
    return selectSelectedArticulationSounds(state);
  }
  if (type === ARTICULATION_SOUNDS_POSITIONS) {
    return selectSelectedArticulationSoundPositions(state);
  }
  if (type === VOCABULARY_CATEGORIES) {
    return selectSelectedCategories(state);
  }
  if (type === NUM_OF_SYLLABLES) {
    return selectNumOfSyllables(state);
  }
  if (type === SYLLABLES_SHAPES) {
    return selectSyllablesShapes(state);
  }
  if (type === THEMES) {
    return selectSelectedThemes(state);
  }
  if (type === GRADES) {
    return selectSelectedGrades(state);
  }
};

const getDefaultProperties = (state) => {
  const selectedFilter = selectSelectedFilter(state);
  const selectedGrade = selectSelectedGrades(state);
  const selectedThemes = selectSelectedThemes(state);

  return {
    h5p_field: selectedFilter?.areaOfNeedName || "",
    h5p_protocol: selectedFilter?.protocolName || "",
    h5p_grade: selectedGrade || [],
    h5p_themes: selectedThemes || [],
  };
};

const getFilterSet = (state) => {
  const selectedGame = selectSelectedGame(state);
  
  const isCategoryFilter = getIsCategoryFilter(selectedGame);
  const isSoundFilter = getIsSoundFilter(selectedGame);

  const selectedArticulationSounds = selectSelectedArticulationSounds(state);
  const selectedArticulationSoundPositions = selectSelectedArticulationSoundPositions(state);
  const selectedVocabularyCategories = selectSelectedCategories(state);
  const numOfSyllables = selectNumOfSyllables(state);
  const syllablesShapes = selectSyllablesShapes(state);

  return [
    isSoundFilter && selectedArticulationSounds?.length && ARTICULATION_SOUNDS,
    isSoundFilter && selectedArticulationSoundPositions?.length && ARTICULATION_SOUNDS_POSITIONS,
    isSoundFilter && numOfSyllables?.length > 0 && NUM_OF_SYLLABLES,
    isSoundFilter && syllablesShapes?.length > 0 && SYLLABLES_SHAPES,
    
    isCategoryFilter && selectedVocabularyCategories?.length && "vocabulary_categories",
  ].filter(Boolean).join(", ");
};


export const trackVocabularyEvent = (eventName, state, additionalParams = {}, callback = null) =>
  setTimeout(() => {
    try {
      selectTrackEventsFunc(state)(eventName, { ...getDefaultProperties(state), ...additionalParams });
      callback?.();
    } catch (e) {
      console.error(`failed to send student group analytics ${eventName}: ${e}`);
    }
  }, 1);

export const trackGamesSelectEvent = (state, stateBefore, additionalParams = {}, callback = null) => {
  const selectedGame = selectSelectedGame(state);
  const prevSelectedGame = selectSelectedGame(stateBefore);
  const game = selectedGame || prevSelectedGame;
  const h5p_filters_set = getFilterSet(state);

  const params = {
    external_id: game?.external_id,
    game_id: game?.id,
    h5p_game_type: game?.game_type || "",
    h5p_is_articulation: game?.is_articulation || false,
    h5p_is_expressive: game?.is_expressive || false,
    h5p_is_manual: game?.is_manual || false,
    h5p_is_naming: game?.is_naming || false,
    h5p_objective: game?.objective_title || "",
    h5p_game_title: game?.title || "",
    h5p_filters_set,
  };
  
  trackVocabularyEvent(
    selectedGame ? "H5P_game_selecting" : "H5P_game_deselecting",
    state,
    { ...additionalParams, ...params },
    callback,
  );
};

export const trackcChangedFilterEvent = (state, stateBefore, additionalParams = {}, callback = null) => {
  const generateGameError = selectGenerateGameError(stateBefore);

  const val_before = getStateByType(additionalParams.filter_name, stateBefore);
  const val_after = getStateByType(additionalParams.filter_name, state);

  const h5p_filters_set = getFilterSet(state);
  let is_selection;
  let num_filters;
  if (Array.isArray(val_before) && Array.isArray(val_after)) {
    is_selection = val_after.length > val_before.length;
    num_filters = val_after.length;
  } else {
    is_selection = val_after > val_before;
    num_filters = 1;
  }

  const params = {
    h5p_filters_set,
    num_filters,
    is_selection,
    not_enough_words: !!generateGameError,
  };
  trackVocabularyEvent("H5P_change_filter", state, { ...additionalParams, ...params }, callback);
};

export const trackcOpenFilterEvent = (state, additionalParams = {}, callback = null) => {
  const h5p_filters_set = getFilterSet(state);
  const params = {
    h5p_filters_set,
  };

  trackVocabularyEvent("H5P_filter_open", state, { ...additionalParams, ...params }, callback);
};
